/**
 * StorySceneNode - scene card rendered inside an SVG foreignObject
 * Used by StoryFlowCanvas for the story DAG view
 *
 * @author    Claude / contexagon GmbH
 */

import React from 'react';


export const NODE_WIDTH = 170;
export const NODE_HEIGHT = 60;
export const START_NODE_WIDTH = 80;
export const START_NODE_HEIGHT = 32;
export const END_NODE_WIDTH = 80;
export const END_NODE_HEIGHT = 32;


function SceneCard({ node, isSelected, onClick }) {
    const actionCount = node.actionCount;
    const [hovered, setHovered] = React.useState(false);

    return (
        <div
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                width: NODE_WIDTH,
                height: NODE_HEIGHT,
                backgroundColor: 'white',
                border: isSelected
                    ? '2px solid #1976d2'
                    : hovered
                        ? '1.5px solid #90caf9'
                        : '1.5px solid #e0e0e0',
                borderRadius: 8,
                padding: '8px 12px',
                boxSizing: 'border-box',
                cursor: 'pointer',
                boxShadow: hovered
                    ? '0 4px 14px rgba(0,0,0,0.13)'
                    : isSelected
                        ? '0 2px 8px rgba(25,118,210,0.18)'
                        : '0 1px 4px rgba(0,0,0,0.07)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                userSelect: 'none',
                transition: 'box-shadow 0.12s, border-color 0.12s',
                overflow: 'hidden',
                backgroundColor: isSelected ? '#e8f4fd' : 'white',
            }}
        >
            <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: isSelected ? '#1565c0' : '#222',
                lineHeight: 1.3,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
                {node.label}
            </div>
            {actionCount !== undefined && (
                <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>
                    {actionCount} Aktion{actionCount !== 1 ? 'en' : ''}
                </div>
            )}
        </div>
    );
}


function StartNode({ node }) {
    return (
        <div style={{
            width: START_NODE_WIDTH,
            height: START_NODE_HEIGHT,
            backgroundColor: '#e8f5e9',
            border: '2px solid #66bb6a',
            borderRadius: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 800,
            color: '#2e7d32',
            letterSpacing: 0.5,
            userSelect: 'none',
        }}>
            START
        </div>
    );
}


function EndNode({ node }) {
    const isRefusal = node.endType === 'refusal';
    return (
        <div style={{
            width: END_NODE_WIDTH,
            height: END_NODE_HEIGHT,
            backgroundColor: isRefusal ? '#fff3e0' : '#f5f5f5',
            border: `2px solid ${isRefusal ? '#ffa726' : '#bdbdbd'}`,
            borderRadius: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            fontWeight: 800,
            color: isRefusal ? '#e65100' : '#757575',
            letterSpacing: 0.5,
            userSelect: 'none',
        }}>
            {isRefusal ? 'REFUSAL' : 'EXIT'}
        </div>
    );
}


export function StorySceneNode({ node, isSelected, onClick }) {
    if (node.type === 'start') return <StartNode node={node} />;
    if (node.type === 'end') return <EndNode node={node} />;
    return <SceneCard node={node} isSelected={isSelected} onClick={onClick} />;
}

export default StorySceneNode;
